export enum AddonPerformanceAccountFee {
  MONTHLY = 'performance_fee_monthly',
  LIFETIME_ONE_TIME = 'performance_fee_lifetime_one_time',
  LIFETIME_PAY_UPFRONT = 'performance_fee_lifetime_pay_upfront',
  LIFETIME_PAY_PARTIAL = 'performance_fee_lifetime_pay_partial',
}

export default AddonPerformanceAccountFee;
